const defaultState = {
  generalNoteStatusTypes: [],
  loading: false,
  error: false,
  errorMessage: null,
};

export const actionTypes = {
  getNoteStatusTypes: 'GET_NOTE_STATUS_TYPES',
  catchError: 'CATCH_ERROR',
};

export const generalNoteStatusTypesReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionTypes.getNoteStatusTypes: {
      const {generalNoteStatusTypes} = action.payload;
      return {
        ...state,
        generalNoteStatusTypes,
        loading: false,
        error: false,
        errorMessage: null
      }
    }
    case actionTypes.catchError: {
      const error = `NOTE STATUS TYPES OPTIONS: ${action.payload.error}`;
      return {...state, error};
    }
    default:
      return state;
  }
};


export const actions = {
  getNoteStatusTypes: (data) => ({
    type: actionTypes.getNoteStatusTypes,
    payload: data
  }),
  catchError: (error) => ({
    type: actionTypes.catchError,
    payload: error
  }),
};
